import { useLayoutEffect, useState } from 'react'
import { useTelegram } from './useTelegram'

export const useViewport = () => {
  const { tg } = useTelegram()

  const [viewport, setViewport] = useState({
    height: window.innerHeight,
    safeAreaTop: 0,
    isFullscreen: false,
  })

  useLayoutEffect(() => {
    const updateOffsets = () => {
      const safeAreaTop = tg.safeAreaInset.top || 0
      const contentSafeAreaTop = tg.contentSafeAreaInset.top || 0
      const totalTop = safeAreaTop + contentSafeAreaTop

      setViewport(prev => ({
        ...prev,
        safeAreaTop: totalTop,
        isFullscreen: tg.isFullscreen,
      }))
    }

    updateOffsets()
    tg.onEvent('viewportChanged', updateOffsets)

    return () => {
      tg.offEvent('viewportChanged', updateOffsets)
    }
  }, [tg])

  return viewport
}
